import cn from "classnames"

import { Divider, Flex, Space, Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./HeadingCard.module.scss"

import type { HeadingCardProps } from "."

export const HeadingCard: React.FC<HeadingCardProps> = (props) => {
  const { title, subTitle, isBeta, aside, capitalize, ...popover } = props
  const popoverProps =
    popover?.titlePopover || popover?.contentPopover
      ? {
          title: popover.titlePopover,
          content: popover.contentPopover,
          className: popover.classNamePopover,
          placement: popover.placementHeaderInfoPopover
        }
      : undefined

  return (
    <Space
      className={cn(styles.space, isBeta && styles.beta)}
      separator={
        isBeta && <Divider className={styles.divider} orientation="vertical" />
      }
    >
      <Flex vertical>
        <Heading
          capitalize={capitalize}
          level={5}
          title={title}
          popover={popoverProps}
        />
        <Text className={cn("sm-text-ks", styles.subtitle)}>{subTitle}</Text>
      </Flex>
      {isBeta && <Text className={styles.tag}>Beta</Text>}
      {aside && <Flex justify="flex-end">{aside}</Flex>}
    </Space>
  )
}
